import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorFlagTitle: {
		id: 'servicedesk-insight-inline-editable-attributes.common.editable-attribute.error-flag-title',
		defaultMessage: "We couldn't update your attribute",
		description: 'Error title when failing update an CMDB referenced object attribute',
	},
	errorFlagDescription: {
		id: 'servicedesk-insight-inline-editable-attributes.common.editable-attribute.error-flag-description',
		defaultMessage: 'Please refresh and try again',
		description:
			'Generic error description when failing update an CMDB referenced object attribute',
	},
	editButtonLabel: {
		id: 'servicedesk-insight-inline-editable-attributes.common.editable-attribute.edit-button-label',
		defaultMessage: 'Edit {attributeTypeName}',
		description: 'Edit button label, where {attributeTypeName} is the name of that attribute',
	},
});
